<app-segov-sigepo-portal-body>

  <app-segov-sigepo-header-section [RouteStack]="RouteStack">
  </app-segov-sigepo-header-section>
  <div class="body-autenticidade">
    <div class="default-spacing-title" style="padding-top: 2rem;">
      <h2 style="font-weight: 600; margin-bottom: 1rem;">{{ mensagensAutenticidade.Titulo }} <span class="text-em-destaque">{{ mensagensAutenticidade.TituloDestaque }}</span></h2>
      <p>{{ mensagensAutenticidade.Descricao }}</p>
    </div>

    <div class="search-bar-line-autenticidade-bg" >
      <form class="default-spacing-title" [formGroup]="formCodigo">
        <h2 class="titulo-informe-codigo">{{ mensagensAutenticidade.InformeCodigo }}</h2>
        <div class="input-autenticidade">
          <app-codigo-input
            formControlName="codigo"
            [placeholder]="mensagensAutenticidade.PlaceholderCodigo"
            [Fieldtype]="'number'"
            [buttonText]="mensagensAutenticidade.BotaoVerificar"
            [corBotao] = "'var(--tom-3-autenticacao)'"
            [corTextoBotao] = "'white'"
            (buttonClick) = "ObterPaginaPorAutenticidadePesquisa()"
          />
        </div>
        <span class="error-message">{{formCodigo.controls['codigo'].errors ? formCodigo.controls['codigo'].errors['TextError'] : ''}}</span>
      </form>
    </div>

    @if(pesquisaRealizada){
      <div class="default-spacing-title" style="padding-top: 2rem; padding-bottom: 2rem;">
        <app-listagem-retorno-autenticidade
        [blob] = "blob"
        [PaginaJornalOutputDto] = "paginaJornalOutputDto"
        (ClickCloseOutput) = "reiniciarPagina()" />
      </div>
    }

    <div class="default-spacing-title">
      <h4 style="font-weight: 600;">{{ mensagensAutenticidade.OndeEncontrar }}</h4>
      <div class="instrucoes-autenticidade">
        <section class="instrucao-autenticidade">
          <p><strong>{{ mensagensAutenticidade.APartirDeSetembro2026 }}</strong><br>
            {{ mensagensAutenticidade.InstrucaoPublicacaoHtml }}</p>
          <img class="imagem-instrucao-autenticidade" src="images/imagem_codigo_autenticidade_html.png" [alt]="mensagensAutenticidade.DescricaoPublicacaoHtml"/>
        </section>
        <section class="instrucao-autenticidade">
          <p><strong>{{ mensagensAutenticidade.DeMarco2019AAgosto2026 }}</strong><br>
            {{ mensagensAutenticidade.InstrucaoPdf }}</p>
          <img class="exibe-tela-maior-993 imagem-instrucao-autenticidade" src="images/imagem_codigo_autenticidade.png" [alt]="mensagensAutenticidade.DescricaoPdf"/>
          <img class="exibe-tela-menor-993 imagem-instrucao-autenticidade" src="images/imagem_codigo_autenticidade_mobile.png" [alt]="mensagensAutenticidade.DescricaoPdf"/>
        </section>
      </div>
    </div>
    <div class="default-spacing-title" style="padding-bottom: 2rem;">
      <h4 style="font-weight: 600;">{{ mensagensAutenticidade.SobreCodigo }}</h4>
      <p>{{ mensagensAutenticidade.DescricaoCodigo }}</p>
    </div>
  </div>
</app-segov-sigepo-portal-body>
